export enum ECookieConsentStringMappingEnum {
    Version = 'v=',
    TechnicalRequired = '&t=',
    Functional = '&f=',
    Statistics = '&s=',
    Marketing = '&m='
}
